
define('template!superAdminMbAnaResListTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="content">\n    <div class="well jq-grid-table-page">\n        <div class="mbanares-table">\n            <div class="form-group add-new-block">\n                <a href="#superAdmin/mbanaresgrs/' +
((__t = ( data.model.get('secId') )) == null ? '' : __t) +
'/mbanares/new" class="btn new-mbAnaRes-button add-btn-text">\n                    <i class="mdi-content-add"></i>\n                    <span>' +
((__t = ( _.i18n('mbanares.new') )) == null ? '' : __t) +
'</span>\n                </a>\n            </div>\n            <table id="jq-grid-list" class="mbAnaResTable" role="grid"></table>\n            <div id="jq-grid-pager-list"></div>\n        </div>\n    </div>\n</div>';

}
return __p
};});

